import { render } from "./App.vue?vue&type=template&id=6733d938"
const script = {}

import exportComponent from "D:\\phpstudy_pro\\WWW\\tgl.liuxianfa.cn\\mobileNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__